export default __webpack_public_path__ + "static/media/s4_title-springs.6e616513.png";